<template>
  <transition name="fade" mode="out-in" appear>
    <router-view></router-view>
  </transition>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/css/font-awesome.min.css';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/css/simple-line-icons.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';

  // Import Main styles for this application
  @import './scss/style';

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }

  [disabled] {
    cursor: not-allowed;
  }

  .app-body .main {
    background-color: #e4e5e6;
  }

  .app-header.navbar .navbar-brand {
    background-size: auto 100%;
  }

  .brand-minimized .app-header.navbar .navbar-brand {
    background-size: auto 70%;
  }

  .sidebar-nav .nav-dropdown.open > .nav-dropdown-items {
    background-color: rgba(0,0,0,.3);
    box-shadow: inset 0 0 3px rgba(0,0,0,.5);
  }
</style>



// WEBPACK FOOTER //
// App.vue?e6d54692